import Icon from '@ant-design/icons'

const SVG = () => (
    <svg
        t='1673596868528'
        className='icon'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='7932'
    >
        <path
            d='M263.6 340.4c0 136.8 110.8 248 248 248 136.8 0 248-110.8 248-248 0-136.8-110.8-248-248-248-137.2 0.4-248 111.2-248 248z m0 0'
            fill='currentColor'
            p-id='7933'
        ></path>
        <path
            d='M750.8 586.8c-19.6-15.6-47.6-14-66 4.4C640 636 578.4 664 510 664c-68.8 0-130.4-28-175.2-72.8-18.4-18.4-46.4-21.2-66-4.4-75.6 64.4-131.6 147.2-150 260.4-7.2 46.4 25.2 84 72.8 84h640c46.4 0 80-38 72.8-84-19.2-113.2-75.2-196-153.6-260.4z m0 0'
            fill='currentColor'
            p-id='7934'
        ></path>
    </svg>
)

export const NickNameIcon = props => <Icon component={SVG} {...props} />
